import React from 'react';
import {
    Card,
    CardContent,
} from '@material-ui/core';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    mainColumn: {
        display: "flex", flexDirection: "column", justifyContent: "space-around", height:"100%",
    },
    divRow: {
        display: "flex", flexDirection: "row", justifyContent: "center", alignItems:'center'
    },
    title: {
        color: "#3D4977",
        textAlign: "center",
        fontFamily: "EncodeSansBold",
        fontSize:"13px",
        maxWidth: "80%",
        alignSelf: "center"
    },
    iconCircle: {
        height: "24px",
        width: "24px",
        borderRadius: "50%",
        display: "inline-block",
    },
    value: {
        fontFamily: "EncodeSansBold",
        fontSize: "20px",
    }
}));


function AdviserDashboardCard(props) {
    const classes = useStyles();
    const title = props.title;
    const value = props.value;
    const cursor = props.cursor;
    const backColor = props.backColor;
    // const trend = props.trend;
    return (
        <React.Fragment>
            <Card
                style={{cursor: {cursor}, width: "210px", height:"104px", backgroundColor: backColor}}
            >
                <CardContent style={{height:"100%", padding:"8px"}}>
                    <div className={classes.mainColumn}>
                        <p className={classes.title}>{title}</p>
                        <div className={classes.divRow}>
                            {/*<div className={classes.iconCircle} style={{backgroundColor: "#bb0d67"}}>*/}
                            {/*    {trend === 1*/}
                            {/*        ? <ArrowUpwardIcon style={{color: "#fff"}}/>*/}
                            {/*        : <ArrowDownwardIcon style={{color: "#fff"}}/>}*/}
                            {/*</div>*/}
                            <p className={classes.value} style={{color: "#bb0d67"}}>{value}</p>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </React.Fragment>
    );
}

export default AdviserDashboardCard;
